import styled, { css } from 'styled-components';

import { color, media } from 'app/shared/styles_js/variables';

import { GridContainerSt } from './shared/components/Grid/Grid.css';

export const mobileHeaderHeight = 64;
export const headerHeight = 128;

export const SectionMainHeadingSt = styled.span`
  position: relative;
  display: block;
  margin-bottom: 24px;
  padding: 16px 0 0 0;
  font-size: 24px;
  font-weight: bold;
  line-height: 1.67;
  letter-spacing: 0.4px;
  color: ${color.brandSecondary};
  text-align: center;

  ${media.md(css`
    font-size: 32px;
    line-height: 1.13;
    letter-spacing: normal;
    ${({ hasSubline }) => `margin: 0 0 ${hasSubline ? '28px' : '64px'};`}
    text-align: left;
  `)};

  ${media.xl(css`
    font-size: 40px;
  `)};

  &::before {
    position: absolute;
    top: 0;
    left: 50%;
    width: 44px;
    height: 4px;
    transform: translateX(-50%);
    background-color: ${color.brandPrimary};
    content: '';
    ${media.md(css`
      left: 0;
      transform: translateX(0%);
    `)};
  }
`;

export const SectionGridContainerSt = styled(GridContainerSt)`
  padding-bottom: ${({ noPadding }) => (noPadding ? '0px' : '64px')};
`;

export const aspectPaddingBottom = (width, height) =>
  `${(height / width) * 100}%`;

export const aspectRatio = (width, height, directChild = 'img') => {
  return `
    overflow: hidden;
    position: relative;
    padding-bottom: ${aspectPaddingBottom(width, height)};

    > ${directChild} {
      position: absolute;
      display: block;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  `;
};

const topBarStyles = css`
  position: absolute;
  top: 0;
  left: calc(50% - 24px);
  width: 48px;
  height: 4px;
  background-color: ${color.brandPrimary};
  content: '';

  ${media.md(css`
    left: 0;
  `)};
`;
export const SectionHeadlineSt = styled.div`
  position: relative;
  padding-top: 16px;
  text-align: center;
  font-size: 20px;
  font-weight: 400;

  &::before {
    ${topBarStyles}
  }

  ${media.md(css`
    margin: 0 0 40px;
    font-size: 24px;
    text-align: left;
  `)};

  ${({ isBold }) =>
    isBold &&
    css`
      font-weight: bold;
    `}

  ${({ isModuleHeadline }) =>
    isModuleHeadline &&
    css`
      font-weight: bold;
      font-size: 20px;
      line-height: 1.6;
      margin-bottom: 40px;
      &::before {
        ${topBarStyles}
        left: calc(50% - 20px);
        width: 40px;
      }
      ${media.md(css`
        font-size: 20px;
      `)};
    `}
`;

export const DealerEmptySt = styled.div`
  display: flex;
  width: 100%;
  min-height: 80px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  color: ${color.grayLight};
`;
